const API_URL = process.env.REACT_APP_API_URL_PROD;

const getSearch = async (query) => {
    if (!query.trim()) {
        return [];
    }

    const token = localStorage.getItem("access_token_esti");

    try {
        const response = await fetch(`${API_URL}/books/search/?query=${encodeURIComponent(query)}`, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.status} ${response.statusText}`);
        }

        const books = await response.json();
        return books;
    } catch (error) {
        console.error("Іздеу қатесі:", error);
        return [];
    }
};

export default getSearch;